/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — empty connection / primary actions.
 */
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export function NoConnectionBanner({
  message = 'No Amazon connection.',
  connectPath = '/amazon/connect',
}: {
  message?: string;
  connectPath?: string;
}) {
  return (
    <p
      className="rounded-[var(--shell-radius-md)] border border-[var(--shell-warning)]/40 bg-[var(--shell-surface-elevated)] px-3 py-2 text-sm text-[var(--shell-fg)]"
      role="status"
    >
      {message}{' '}
      <Link to={connectPath} className="font-medium text-[var(--shell-accent)] underline">
        Connect a seller
      </Link>{' '}
      first.
    </p>
  );
}

export function SyncOnConnectAction({
  to = '/amazon/connect',
  children = 'Sync on Connect',
}: {
  to?: string;
  children?: ReactNode;
}) {
  return (
    <Link
      to={to}
      className="inline-flex min-h-11 items-center rounded-[var(--shell-radius-md)] bg-[var(--shell-fg)] px-3 text-sm font-medium text-[var(--shell-canvas)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--shell-focus-ring)]"
    >
      {children}
    </Link>
  );
}

export function ConnectEmptyAction({
  to = '/amazon/connect',
  children = 'Open Connect',
}: {
  to?: string;
  children?: ReactNode;
}) {
  return (
    <Link
      to={to}
      className="rounded-[var(--shell-radius-md)] bg-[var(--shell-fg)] px-4 py-2 text-sm text-[var(--shell-canvas)]"
    >
      {children}
    </Link>
  );
}
